{
  "title": "排程監控",
  "loading": "載入中",
  "refresh": "重新整理",
  "lastSnapshot": "最後同步",
  "enabled": "啟用",
  "disabled": "停用",
  "days": "天",
  "searchHint": "搜尋…",
  "searchTooltip": "可搜尋：action / id / executionId / universalId / phase / status / error",
  "triggerSource": {
    "Schedule": "定時",
    "Manual": "手動",
    "Event": "事件",
    "Transient": "臨時"
  },
  "scheduleType": {
    "Cron": "Cron",
    "Once": "單次",
    "Startup": "啟動",
    "OnDemand": "待命"
  },
  "jobStatus": {
    "title": "工作狀態總表",
    "empty": "尚無工作狀態",
    "colPhase": "階段",
    "colStatus": "狀態",
    "colAction": "工作",
    "colId": "ID",
    "colTime": "時間",
    "colRetry": "重試",
    "colMessage": "訊息"
  },
  "summary": {
    "total": "排程總數",
    "inProgress": "進行中",
    "enabled": "啟用中",
    "retryChains": "重試鏈"
  },
  "roster": {
    "title": "排程清單",
    "empty": "目前沒有排程",
    "id": "識別碼",
    "description": "描述",
    "action": "動作",
    "type": "類型",
    "schedule": "排程時間",
    "nextFire": "下次觸發",
    "due": "已到期",
    "autoAdvance": "推進",
    "fixedRate": "物理時間(Fixed Rate):點火後立即排下一期",
    "fixedDelay": "業務時間(Fixed Delay):完成後才排下一期",
    "advanceNa": "單次排程無推進策略(不適用)",
    "enabled": "狀態",
    "operation": "操作",
    "globalOffHint": "排程器已全域停用（SchedulerEnabled=false）：個別啟停暫不可用，請改 control.json 解除。",
    "srcManual": "手動",
    "srcManualHint": "此排程的啟停為手動設定，已覆寫設定檔的定義值。"
  },
  "inProgress": {
    "title": "進行中任務",
    "empty": "目前沒有進行中的任務",
    "id": "識別碼",
    "action": "動作",
    "elapsed": "已執行",
    "startedAt": "開始於"
  },
  "feed": {
    "title": "即時事件",
    "empty": "尚無事件",
    "colPhase": "階段",
    "colStatus": "狀態",
    "colAction": "工作",
    "colId": "ID",
    "colTime": "時間",
    "colRetry": "重試",
    "colMessage": "訊息"
  },
  "retry": {
    "title": "重試鏈"
  },
  "phase": {
    "Dispatched": "已派發",
    "Succeeded": "成功",
    "Failed": "失敗",
    "Retrying": "重試中",
    "GaveUp": "已放棄",
    "Running": "執行中"
  },
  "detail": {
    "title": "事件詳情",
    "view": "查看詳情",
    "copy": "複製",
    "copied": "已複製",
    "copyFailed": "複製失敗",
    "universalId": "Universal ID（批次身分）",
    "originalId": "原 ID（本次執行）",
    "executionId": "執行實例 ID",
    "phase": "階段",
    "action": "工作",
    "triggerSource": "觸發來源",
    "scheduleType": "排程類型",
    "jobSequenceNo": "序號",
    "status": "狀態",
    "retry": "重試次數",
    "dueTime": "預定時間",
    "runTime": "執行時間",
    "eventTime": "事件時間",
    "lastError": "錯誤訊息"
  },
  "manualTrigger": {
    "title": "手動觸發排程",
    "tooltip": "手動觸發",
    "target": "觸發對象",
    "secretLabel": "請輸入密碼以確認",
    "secretPlaceholder": "登入密碼",
    "confirm": "觸發",
    "cancel": "取消",
    "disabledWarning": "此排程目前為停用狀態，手動觸發將強制執行一次。",
    "params": {
      "section": "額外參數（選填）",
      "logicalTime": "邏輯時間",
      "logicalTimePlaceholder": "不指定則由程式自行決定",
      "keyPlaceholder": "參數名",
      "valuePlaceholder": "值",
      "add": "新增自訂參數",
      "hint": "參數會以 {'@'} 前綴存入，供後端工作自行取用；某工作是否使用某參數由後端決定。",
      "errFormat": "參數名僅能使用英數字與底線",
      "errReserved": "此參數名與預定義參數重複",
      "errDuplicate": "參數名不可重複"
    },
    "notify": {
      "triggeredTitle": "已觸發",
      "triggeredDetail": "排程已開始執行，可至即時動態查看進度。",
      "wrongSecretTitle": "密碼錯誤",
      "wrongSecretDetail": "輸入的密碼不正確，請重新輸入後再試一次。",
      "authUnavailableTitle": "無法驗證",
      "authUnavailableDetail": "驗證服務暫時無法使用，請稍後再試或聯絡管理員。",
      "failedTitle": "觸發失敗",
      "failedDetail": "無法觸發此排程，請稍後再試。",
      "forbiddenTitle": "無權限",
      "forbiddenDetail": "您沒有權限觸發此排程，此操作僅限管理員。"
    }
  },
  "setEnabled": {
    "title": "排程啟停",
    "target": "目標排程",
    "toEnable": "將啟用",
    "toDisable": "將停用",
    "reasonLabel": "理由（選填）",
    "reasonPlaceholder": "變更原因，可留空",
    "secretLabel": "確認密碼",
    "secretPlaceholder": "輸入您的登入密碼",
    "cancel": "取消",
    "confirm": "確認",
    "enableTip": "啟用此排程",
    "disableTip": "停用此排程",
    "globalOffTip": "排程器已全域停用，個別啟停不可用",
    "notify": {
      "sentTitle": "已送出",
      "sentDetail": "啟停指令已送出，稍候清單會更新",
      "wrongSecretTitle": "密碼錯誤",
      "wrongSecretDetail": "請確認您的登入密碼",
      "authUnavailableTitle": "驗證服務不可用",
      "authUnavailableDetail": "請稍後再試",
      "reasonTooLongTitle": "理由過長",
      "reasonTooLongDetail": "理由請勿超過 200 字",
      "failedTitle": "操作失敗",
      "failedDetail": "請稍後再試",
      "forbiddenTitle": "無權限",
      "forbiddenDetail": "您沒有權限變更此排程啟停，此操作僅限管理員。"
    }
  },
  "history": {
    "title": "執行歷史查詢",
    "selectSchedule": "選擇排程（可複選）",
    "selectPlaceholder": "從現存排程選擇…",
    "queryByValue": "或指定查詢",
    "valuePlaceholder": "輸入完整值（依類型；SourceId 可查已刪/瞬態）",
    "dateRange": "時間區間",
    "phase": "最後階段",
    "statusAll": "全部",
    "query": "查詢",
    "empty": "查無執行紀錄",
    "col": {
      "phase": "階段",
      "status": "狀態",
      "action": "動作",
      "id": "ID",
      "time": "時間",
      "retries": "重試",
      "lastError": "最後錯誤"
    },
    "chain": {
      "phase": "階段",
      "time": "時間",
      "retry": "重試",
      "exec": "執行 ID",
      "error": "錯誤",
      "empty": "無事件"
    },
    "notify": {
      "failedTitle": "查詢失敗",
      "failedDetail": "無法取得執行歷史，請稍後再試。"
    }
  }
}